import { RESOURCE_PLAN_CONFIRMATION_TYPE } from "@src/constants";
import { BaseTableFilters, BaseTableState, EmployeeV2 } from "@src/types";
import { DigixProject } from "@src/types/project_types";
import {
  RoleRequest,
  WorkloadTableRowData,
} from "@src/types/role_request_types";

export interface ResourcePlan {
  resourcePlanId: number;
  resourcePlanName: string;
  projects: DigixProject[];
  editors: EmployeeV2[];
}

export interface ResourcePlanOverviewTableRowData {
  resourcePlanId: number;
  resourcePlanName: string;
  totalStaffed: number;
  totalRequested: number;
  totalOpen: number;
  totalActionRequired: number;
  projects: DigixProject[];
}

export interface DataConfirmationHistory {
  confirmationId: number;
  resourcePlanId: number;
  confirmedById: number;
  confirmedByName: string;
  confirmationDate: Date;
  confirmedType: RESOURCE_PLAN_CONFIRMATION_TYPE;
}

export enum RESOURCE_PLAN_FILTER_TYPES_V2 {
  STANDARD_ROLE_NAMES = "standardRoleName",
  STATUS = "status",
  JOINT_VENTURE = "jointVenture",
  ACTION_REQUIRED = "actionRequired",
  DECLINED_BY_PROJECT = "isDeclined",
  NEW_COMMENTS = "isCommentAvailable",
}

export type ResourcePlanTableStateV2 = BaseTableState<
  RoleRequest,
  ResourcePlanFilters,
  null
>;

export interface ResourcePlanFilters extends BaseTableFilters {
  [RESOURCE_PLAN_FILTER_TYPES_V2.STANDARD_ROLE_NAMES]: string[];
  [RESOURCE_PLAN_FILTER_TYPES_V2.STATUS]: string[];
  [RESOURCE_PLAN_FILTER_TYPES_V2.DECLINED_BY_PROJECT]: boolean;
  [RESOURCE_PLAN_FILTER_TYPES_V2.NEW_COMMENTS]: boolean;
  [RESOURCE_PLAN_FILTER_TYPES_V2.JOINT_VENTURE]: boolean;
  [RESOURCE_PLAN_FILTER_TYPES_V2.ACTION_REQUIRED]: boolean;
}

export interface ResourcePlanState {
  projectId: string;
  isJointVentureProject: boolean;
  jointVenturePartner?: string;
  totalDraftRequests?: number;
  isProjectEnded?: boolean;
  resourcePlanTableState: ResourcePlanTableStateV2;
}

export interface ChangelogAllocationItem {
  allocationPercentage: number;
  date: Date;
}

export interface ChangelogFieldChange {
  fieldName: string;
  oldValue: string | ChangelogAllocationItem[];
  newValue: string | ChangelogAllocationItem[];
  type: string;
  revision: number;
  modifiedBy: string;
  creationTime: Date;
}
export interface ChangelogTableFieldChange extends ChangelogFieldChange {
  oldValue: string;
  newValue: string;
  allocations?: WorkloadTableRowData[];
}

export interface ChangelogItem {
  fieldChange: ChangelogFieldChange;
  projectRoleRequestId: number;
}

export interface ChangelogTableItem {
  fieldChange: ChangelogTableFieldChange;
  projectRoleRequestId: number;
}
